import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useCreateSEPASetup(clubId: string) {
	return useMutation({
		mutationFn: ({
			memberId,
			data,
		}: {
			memberId: string;
			data: {
				email: string;
				name: string;
				success_url: string;
				cancel_url: string;
			};
		}) => financeApi.billing.createSEPASetup(clubId, memberId, data),
	});
}

export function useCreateSubscription(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ memberId, feeId }: { memberId: string; feeId: string }) =>
			financeApi.billing.createSubscription(clubId, memberId, {
				fee_id: feeId,
			}),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.subscriptions(clubId),
			}),
	});
}

export function useMemberSubscriptions(clubId: string | null, memberId: string) {
	return useQuery({
		queryKey: queryKeys.clubPortal.memberSubscriptions(clubId ?? "", memberId),
		queryFn: () => financeApi.billing.listMemberSubscriptions(clubId!, memberId),
		enabled: !!clubId && !!memberId,
	});
}

export function useClubSubscriptions(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.subscriptions(clubId ?? ""),
		queryFn: () => financeApi.billing.listClubSubscriptions(clubId!),
		enabled: !!clubId,
	});
}

export function useCancelSubscription(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (subId: string) => financeApi.billing.cancelSubscription(clubId, subId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.subscriptions(clubId),
			}),
	});
}
